// 준공·현장 닫기의 「무엇을 쓸지」 — 인메모리·Supabase 가 한 벌을 쓴다.

import dayjs from "dayjs";

import type { Project, ProjectCompleteInput } from "./types";

// 개월 더하기 — 없는 날은 그 달 말일로 붙인다(1/31 + 1개월 = 2/28).
export const addMonthsClamped = (date: string, months: number): string =>
  dayjs(date).add(months, "month").format("YYYY-MM-DD");

export const warrantyEndDate = (completionDate: string, warrantyMonths: number): string =>
  addMonthsClamped(completionDate, warrantyMonths);

export type ProjectCloseoutPatch = Pick<Project, "status" | "completion_date" | "warranty_end_date" | "closed_at">;

export const buildComplete = (input: ProjectCompleteInput, at: string): ProjectCloseoutPatch => ({
  status: input.next,
  completion_date: input.completion_date,
  warranty_end_date: input.next === "WARRANTY" ? warrantyEndDate(input.completion_date, input.warranty_months) : null,
  closed_at: input.next === "CLOSED" ? at : null,
});

export const buildClose = (at: string): Pick<Project, "status" | "closed_at"> => ({
  status: "CLOSED",
  closed_at: at,
});

export const buildWarrantyEnd = (date: string): Pick<Project, "warranty_end_date"> => ({
  warranty_end_date: date,
});
